module.exports = __webpack_public_path__ + "img/logo-dark.da7e8acd.svg";